import { Injectable } from '@angular/core';
import { CanLoad, CanActivate, Router } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanLoad {

    constructor(private auth: AuthService, private router: Router){}

    /* Т.к. мы решили после ребилда делать очистку кэша, то нужен переход на страницу 
    логина через объект браузера, что в свою очередь создает проблему бесконечного редиректа 
    (в случае с роутами ангуляра такой проблемы нет из-за того что он не меняет маршрут если 
    url не изменился). В связи с этим, нельзя использовать на незащищенных страницах проверку 
    через AuthService.canLoad / canActivate т.к. всегда будет выброс на страницу логина, но можно 
    использовать дополнительные признаки, типа наличия токена в сторэдже браузера. 
    window.location.href = '/login';
    
    18-01-2018 - Теперь можно. Версию приложения я проверяю в интерцепторе для всех роутов кроме ct и login. 
    А это значит, что теперь нету смысла делать тут хард релоад, т.к. он в любом случае произойдет 
    при обращении на любой другой роут. И можно использовать AuthService.canLoad*/

    //Могу ли я загрузить данный модуль, если возвращается false, 
    //то ангуляр даже грузить его не будет
    canLoad() {
        let canLoad = this.auth.check_permissions_by_url(window.location.pathname);
        if (!canLoad) this.router.navigate(['redirectToRoot']);
        return canLoad;
    }    

    //Могу ли я активировать маршрут роутера
    canActivate(){
        return this.auth.front_permissions().map(valid => valid);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/auth-guard.service.ts